import React  from 'react';
import './App.css';
import * as dashjs from 'dashjs';
import './Court.css';
import CourtLang from './CourtLang.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { MdRadioButtonChecked } from "react-icons/md"

class CourtStream extends React.Component {

	constructor(props) {

		super(props);
		
		this.videoRef = React.createRef();
		this.mediaSource = null;
		this.sourceBuffer = null;
		this.chunkQueue = [];
		this.isBuffering = false;
		this.prevCheckChunksUnixTimeMs = 0;
		this.startupSequenceYN = true;
		this.socket = null;
		this.videoTimeChangedUnixTimeMs = 0;
		this.videoTimeChangedYN = false;
		this.firstChunkUnixTimeSec = 0;
		this.lastLiveHelloUnixTimeSec = 0;
		this.requestMoreVideoChunksYN = false;
		this.interval1 = null;

		this.state = {
			cameraJsonObj: null,
			isPlaying: false,
			error: null,
			liveYN: false,
			year: 0,
			month: 0,
			day: 0,
			hour: 0,
			min: 0,
			sec: 0,
			sliderMin: 0,
			sliderSec: 0,
			requestClipButtonPressedYN: false,
		};

		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleSourceOpen = this.handleSourceOpen.bind(this);
		this.handleSourceClose = this.handleSourceClose.bind(this);
		this.handleUpdateEnd = this.handleUpdateEnd.bind(this);
		this.binarySocketProcessMessageInternal = this.binarySocketProcessMessageInternal.bind(this);
		this.binarySocketProcessMessage = this.binarySocketProcessMessage.bind(this);
		this.handleTimeUpdate = this.handleTimeUpdate.bind(this);
		this.checkVideoTimeChangedUnixTimeMs = this.checkVideoTimeChangedUnixTimeMs.bind(this);
		this.resumePlayback = this.resumePlayback.bind(this);
	}
	
	async componentDidMount() {
        
		var cameraID = this.props.cameraID;
		await this.serverGetCameraData(cameraID);
		this.startBinarySocketConnectionToServer();
		this.setupMediaSource();
		this.interval1 = setInterval(this.checkVideoTimeChangedUnixTimeMs, 1000);
		window.addEventListener("keydown", this.handleKeyDown);
	}

	componentWillUnmount() {

		this.removeStream();

		if (this.interval1 !== null) {
			clearInterval(this.interval1);
			this.interval1 = null;
		}
		
		window.removeEventListener("keydown", this.handleKeyDown);

		var videoElement = this.videoRef.current;
		this.mediaSource.removeEventListener('sourceopen', this.handleSourceOpen);
		this.mediaSource.removeEventListener('sourceclose', this.handleSourceClose);
		videoElement.removeEventListener('ended', this.handleVideoEnded);
		videoElement.removeEventListener('error', this.handleVideoError);
		videoElement.removeEventListener('timeupdate', this.handleTimeUpdate);
	}
	
	handleKeyDown(event) {

		var key = event.key;

		if (key === "ArrowLeft") {

			var videoElement = this.videoRef.current;
			if (!videoElement) {
				return;
			}
			
			videoElement.currentTime = Math.max(videoElement.currentTime - 15, 0);
		}

		if (key === "ArrowRight") {

			var videoElement = this.videoRef.current;
			if (!videoElement) {
				return;
			}

			// make sure we don't go past the video duration
			videoElement.currentTime = Math.min(
				videoElement.currentTime + 15,
				videoElement.duration
			);
		}		
	}

	async serverGetCameraData(cameraID) {
		
		if (cameraID <= 0) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getcameradata?cameraid=" + cameraID;
		
		var cameraJsonObj = null;
		
		try {
			var res = await fetch(url);
			cameraJsonObj = await res.json();
		} catch (err) {
		}
		
		this.setState({
			cameraJsonObj: cameraJsonObj,
		});
	}
	
	async sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	async executeStartupAfterBinarySocketConnected() {

		var now = new Date();
		var year = now.getFullYear();
		var month = now.getMonth() + 1;
		var day = now.getDate();
		var hour = now.getHours();
		var min = 0;
		var sec = 0;

		this.setState({
			year: year,
			month: month,
			day: day,
			hour: hour,
			min: min,
			sec: sec,
		});
		
		this.createNewStream();
		await this.sleep(200);
		this.handleVideoTimeChange(this.state.liveYN, year, month, day, hour, min, sec);
	}

	setupMediaSource() {

		this.mediaSource = new MediaSource();
		var videoElement = this.videoRef.current;
		videoElement.src = URL.createObjectURL(this.mediaSource);

		this.mediaSource.addEventListener('sourceopen', this.handleSourceOpen);
		this.mediaSource.addEventListener('sourceclose', this.handleSourceClose);
		videoElement.addEventListener('ended', this.handleVideoEnded);
		videoElement.addEventListener('error', this.handleVideoError);
		videoElement.addEventListener('timeupdate', this.handleTimeUpdate);
	};

	handleSourceOpen() {

		var videoCodec = "";
		var cameraJsonObj = this.state.cameraJsonObj;
		if (cameraJsonObj !== null) {
			videoCodec = cameraJsonObj.videoCodec;
		}
		
		var mimeType = "";
		if (videoCodec === "h265") {
			mimeType = 'video/mp4; codecs="hvc1.1.6.L93.B0"';
		} else {
			mimeType = 'video/mp4; codecs="avc1.42E01E"';
		}

		if (MediaSource.isTypeSupported(mimeType)) {
			this.sourceBuffer = this.mediaSource.addSourceBuffer(mimeType);
		} else {
			console.error(`MIME type ${mimeType} not supported.`);
			return;
		}

		this.sourceBuffer.addEventListener('updateend', this.handleUpdateEnd);    
	}
  
	handleSourceClose() {
		console.log('MediaSource closed.');
	};
	
	sendMoreLiveChunks() {

		var unixTimeSec1 = this.lastLiveHelloUnixTimeSec;
		var unixTimeSec2 = Math.floor(Date.now() / 1000);
		
		var diffSec = unixTimeSec2 - unixTimeSec1;
		if (diffSec < 10) {
			return;
		}

		this.lastLiveHelloUnixTimeSec = unixTimeSec2;
		console.log("sendMoreLiveChunks - time to send");		

		var reactID = this.props.reactID;
		var locationID = this.props.locationID;

		var jsonObj = {
			command: "sendMoreLiveChunks",
			reactID: reactID,
			locationID: locationID,
		}
		
		this.props.textSocketSendJsonObj(jsonObj);
	}
  
	setCurrentTimestamp(currentTime) {
		
		var liveYN = this.state.liveYN;
		if (liveYN) {
			this.sendMoreLiveChunks();
			return;
		}

		if (this.firstChunkUnixTimeSec === 0) {
			return;
		}
		
		var year1 = this.state.year;
		var month1 = this.state.month;
		var day1 = this.state.day;
		var hour1 = this.state.hour;
		var min1 = this.state.min;
		var sec1 = this.state.sec;
		
		var dateObj1 = new Date();
		dateObj1.setFullYear(year1, month1-1, day1);
		dateObj1.setHours(hour1, min1, sec1, 0);
		var unixTimeSec1 = Math.floor(dateObj1.getTime() / 1000);
		
		var unixTimeSec2 = this.firstChunkUnixTimeSec + currentTime;
		
		var diffSec = Math.abs(unixTimeSec2 - unixTimeSec1);
		if (diffSec < 10) {
			return;
		}
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var year2 = dateObj2.getFullYear();
		var month2 = dateObj2.getMonth() + 1;
		var day2 = dateObj2.getDate();
		var hour2 = dateObj2.getHours();
		var min2 = dateObj2.getMinutes();
		var sec2 = dateObj2.getSeconds();

		this.setState({
			year: year2,
			month: month2,
			day: day2,
			hour: hour2,
			min: min2,
			sec: sec2,
		});
	}

	handleTimeUpdate() {

		var video = this.videoRef.current;
		var currentTime = video.currentTime;
		this.setCurrentTimestamp(currentTime);
		
		var unixTimeMs = Date.now();
		if (unixTimeMs - this.prevCheckChunksUnixTimeMs >= 500) {
			this.prevCheckChunksUnixTimeMs = unixTimeMs;
			var liveYN = this.state.liveYN;
			if (!liveYN) {
				var len = this.sourceBuffer.buffered.length;
				if (len === 1) {
					var streamEnd = this.sourceBuffer.buffered.end(0);
					console.log("streamEnd = " + streamEnd);
					var diffSec = streamEnd - currentTime;
					if (diffSec < 5*60) {
						this.requestMoreVideoChunks(1);
					}
				}
			}
		}
	}
	
	resumePlayback() {
		this.requestMoreVideoChunksYN = true;
		var video = this.videoRef.current;
		try {
			if (video.readyState >= 2 && video.paused) { 
				video.play();
			}
		} catch (err) {
		}
	}

	handleUpdateEnd() {

    if (this.chunkQueue.length > 0) {
        const nextChunk = this.chunkQueue.shift();
        this.appendBuffer(nextChunk);
        return;
    }

    const video = this.videoRef.current;
	if (video === null) {
		return;
	}

    if (video.readyState >= 2 && video.paused) { 
    }
    
    // If we've reached the end of the stream, terminate the MediaSource
    // Note: You need a signal from the server to know the stream has ended.
    // if (streamIsFinished && this.mediaSource.readyState === 'open') {
    //     this.mediaSource.endOfStream();
    // }
}


	requestMoreVideoChunks(chunkCount) {
		
		if (!this.requestMoreVideoChunksYN) {
			return;
		}

		var reactID = this.props.reactID;
		var locationID = this.props.locationID;

		var jsonObj = {
			command: "sendMoreVideoChunks",
			reactID: reactID,
			locationID: locationID,
			chunkCount: chunkCount,
		}
		
		this.props.textSocketSendJsonObj(jsonObj);
	}

  handleVideoError(event) {
    console.error("Video element error:", event);
  }

  handleVideoEnded() {
    this.setState({ isPlaying: false });
  }

  queueOrAppend(arrayBuffer) {
    if (this.sourceBuffer && !this.sourceBuffer.updating) {
      this.appendBuffer(arrayBuffer);
    } else {
      this.chunkQueue.push(arrayBuffer);
    }
  }

  appendBuffer(arrayBuffer) {
    if (this.sourceBuffer && this.mediaSource.readyState === 'open') {
      try {
        this.isBuffering = true;
        this.sourceBuffer.appendBuffer(arrayBuffer);
      } catch (e) {
        console.error("Error appending buffer:", e);
      }
    }
  }
  
	startBinarySocketConnectionToServer() {

		var reactID = this.props.reactID;
		var url = "https://radovic.com/open?sockettype=react&reactid=" + reactID;
		var socket = new WebSocket(url);

		this.socket = socket;

		socket.onopen = () => {
			if (this.startupSequenceYN) {
				this.executeStartupAfterBinarySocketConnected();
			}
			this.startupSequenceYN = false;
		};

		socket.onmessage = this.binarySocketProcessMessage;

		socket.onerror = (error) => {
			//console.error("binary socket error:");
			//console.error(error);
		};

		socket.onclose = () => {
			this.socket = null;
			this.startBinarySocketConnectionToServer();
		};
	}
	
	splitBuffers(binaryBuffer2) {
		
		var timestampString = "";
		var binaryBuffer1 = null;

		const view = new Uint8Array(binaryBuffer2);

		// find separator 0x00
		var i;
		var zeroIndex = -1;
		for(i=0; i<view.length; i++) {
			if (view[i] === 0) {
				zeroIndex = i;
				break;
			}
		}

		if (zeroIndex === -1) {
			return { timestampString, binaryBuffer1 };
		}
		
		var bufferTimestamp = view.slice(0, zeroIndex);
		var binaryBuffer1 = view.slice(zeroIndex + 1);

		var decoder = new TextDecoder('utf-8');
		var timestampString = decoder.decode(bufferTimestamp);

		return { timestampString, binaryBuffer1 };
	}
	
	getUnixTimeSecFromTimestampString(timestampString) {

		var year2 = parseInt(timestampString.substring(0, 4), 10);
		var month2 = parseInt(timestampString.substring(4, 6), 10);
		var day2 = parseInt(timestampString.substring(6, 8), 10);
		var hour2 = parseInt(timestampString.substring(8, 10), 10);
		var min2 = parseInt(timestampString.substring(10, 12), 10);
		var sec2 = parseInt(timestampString.substring(12, 14), 10);
		
		//console.log(year2 + " " + month2 + " " + day2 + " " + hour2 + " " + min2 + " " + sec2);

		var dateObj2 = new Date();
		dateObj2.setFullYear(year2, month2-1, day2);
		dateObj2.setHours(hour2, min2, sec2, 0);
		var unixTimeSec2 = Math.floor(dateObj2.getTime() / 1000);
		
		return unixTimeSec2;
	}
	
	compareTimestampStringWithCurrentTimestamp(unixTimeSec2) {

		var year1 = this.state.year;
		var month1 = this.state.month;
		var day1 = this.state.day;
		var hour1 = this.state.hour;
		var min1 = this.state.min;
		var sec1 = this.state.sec;
		
		var dateObj1 = new Date();
		dateObj1.setFullYear(year1, month1-1, day1);
		dateObj1.setHours(hour1, min1, sec1, 0);
		var unixTimeSec1 = Math.floor(dateObj1.getTime() / 1000);
		
		var diffSec = Math.abs(unixTimeSec2 - unixTimeSec1);

		var processChunkYN = false;
		if (diffSec < 5*60) {
			processChunkYN = true;
		}

		return processChunkYN;
	}


	binarySocketProcessMessageInternal(binaryBuffer) {
		
		if (this.sourceBuffer === null) {
			return;
		}

		if (this.sourceBuffer.buffered.length > 0) {
			var lastBufferedEnd = this.sourceBuffer.buffered.end(this.sourceBuffer.buffered.length - 1);      
			this.sourceBuffer.timestampOffset = lastBufferedEnd;
		} else {
			this.sourceBuffer.timestampOffset = 0;
		}

		if (this.sourceBuffer && !this.sourceBuffer.updating) {
			this.appendBuffer(binaryBuffer);
		} else {
			if (this.sourceBuffer) {
				this.chunkQueue.push(binaryBuffer);
			} else {
				console.warn("SourceBuffer not ready to accept data.");
			}
		}
	}

	binarySocketProcessMessage(message) {

		var liveYN = this.state.liveYN;

		var blob = message.data;
		blob.arrayBuffer().then((binaryBuffer2) => {
			var { timestampString, binaryBuffer1 } = this.splitBuffers(binaryBuffer2);
			var unixTimeSec2 = this.getUnixTimeSecFromTimestampString(timestampString);
			var processChunkYN;
			if (liveYN) {
				processChunkYN = true;
			} else {
				processChunkYN = this.compareTimestampStringWithCurrentTimestamp(unixTimeSec2);
			}
			if (processChunkYN) {
				if (this.firstChunkUnixTimeSec === 0) {
					this.firstChunkUnixTimeSec = unixTimeSec2;
				}
				if (binaryBuffer1 !== null) {
					this.binarySocketProcessMessageInternal(binaryBuffer1);
					this.resumePlayback();
					setTimeout(this.resumePlayback, 1000);
				}
			}
		});		
	}
	
	prevDate() {

		var year = this.state.year;
		var month = this.state.month;
		var day = this.state.day;
		
		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);
		
		var unixTimeSec = Math.floor(dateObj.getTime() / 1000);
		var unixTimeSec2 = unixTimeSec - 24*3600;
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var year2 = dateObj2.getFullYear();
		var month2 = dateObj2.getMonth() + 1;
		var day2 = dateObj2.getDate();

		this.setState({
			year: year2,
			month: month2,
			day: day2,
		});

		this.handleVideoTimeChange(this.state.liveYN, year2, month2, day2, this.state.hour, this.state.min, this.state.sec);
	}
	
	nextDate() {

		var year = this.state.year;
		var month = this.state.month;
		var day = this.state.day;
		
		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);
		
		var unixTimeSec = Math.floor(dateObj.getTime() / 1000);
		var unixTimeSec2 = unixTimeSec + 24*3600;
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var year2 = dateObj2.getFullYear();
		var month2 = dateObj2.getMonth() + 1;
		var day2 = dateObj2.getDate();

		this.setState({
			year: year2,
			month: month2,
			day: day2,
		});

		this.handleVideoTimeChange(this.state.liveYN, year2, month2, day2, this.state.hour, this.state.min, this.state.sec);
	}

	datePickerSetDate(dateObj) {

		var year = dateObj.getFullYear();
		var month = dateObj.getMonth() + 1;
		var day = dateObj.getDate();

		this.setState({
			year: year,
			month: month,
			day: day,
		});

		this.handleVideoTimeChange(this.state.liveYN, year, month, day, this.state.hour, this.state.min, this.state.sec);
	}
	
	getDateStringFromYMD(year, month, day) {
		var dateString;
		dateString = this.props.getTwoDigits(day) + "." + this.props.getTwoDigits(month) + "." + year + ".";
		return dateString;
	}
	
	getDateObjFromYMD(year, month, day) {

		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);

		return dateObj;
	}
	
	prevHour() {

		var hour = this.state.hour;

		hour --;
		if (hour < 0) {
			hour = 0;
		}
		
		this.setState({hour: hour});
		this.handleVideoTimeChange(this.state.liveYN, this.state.year, this.state.month, this.state.day, hour, this.state.min, this.state.sec);
	}
	
	setHour(hour) {
		this.setState({hour: hour});
	}
	
	setHourOnBlur(hour) {
		
		hour = parseInt(hour);
		
		if (isNaN(hour)) {
			hour = 0;
		}
		
		if (hour < 0) {
			hour = 0;
		}

		if (hour > 23) {
			hour = 23;
		}

		this.setState({hour: hour});
		this.handleVideoTimeChange(this.state.liveYN, this.state.year, this.state.month, this.state.day, hour, this.state.min, this.state.sec);
	}
	
	nextHour() {

		var hour = this.state.hour;

		hour ++;
		if (hour > 23) {
			hour = 23;
		}
		
		this.setState({hour: hour});
		this.handleVideoTimeChange(this.state.liveYN, this.state.year, this.state.month, this.state.day, hour, this.state.min, this.state.sec);
	}
	
	handleLiveClick() {

		var liveYN = this.state.liveYN;
		liveYN = !liveYN;
		this.setState({liveYN: liveYN});
		
		this.handleVideoTimeChange(liveYN, this.state.year, this.state.month, this.state.day, this.state.hour, this.state.min, this.state.sec);
	}
	
	async emptySourceBuffer(sourceBuffer) {

		// 1. Check if the SourceBuffer is currently busy
		if (sourceBuffer.updating) {
			console.warn("SourceBuffer is currently updating. Cannot perform removal.");
			return;
		}

		// 2. Check if there is anything buffered to remove
		if (sourceBuffer.buffered.length === 0) {
			return;
		}

		// 3. Determine the start and end of the entire buffered range
		// We assume the buffered content is continuous (or we want to clear all ranges).
		// The first range starts at buffered.start(0).
		const start = sourceBuffer.buffered.start(0); 

		// The last range ends at buffered.end(length - 1).
		const end = sourceBuffer.buffered.end(sourceBuffer.buffered.length - 1);

		// 4. Call the remove method
		sourceBuffer.remove(start, end);

		// 5. Handle the asynchronous nature of removal
		// You must wait for the 'updateend' event to confirm removal is complete.
		return new Promise((resolve) => {
				sourceBuffer.addEventListener('updateend', function handleRemoveEnd() {
				// Check if the buffered range is now empty or has shrunk as expected
				if (sourceBuffer.buffered.length === 0 || sourceBuffer.buffered.end(0) < start) {
					sourceBuffer.removeEventListener('updateend', handleRemoveEnd);
					resolve();
				}
			});
		});
	}
	
	checkVideoTimeChangedUnixTimeMs() {
		if (!this.videoTimeChangedYN) {
			return;
		}
		var unixTimeMs = Date.now();
		var diffMs = unixTimeMs - this.videoTimeChangedUnixTimeMs;
		if (diffMs > 2000) {
			this.videoTimeChangedYN = false;
			this.videoTimeChangedUnixTimeMs = diffMs;
			this.handleVideoTimeChangeExecute(this.state.liveYN, this.state.year, this.state.month, this.state.day, this.state.hour, this.state.min, this.state.sec);
		}
	}

	async handleVideoTimeChangeExecute(liveYN, year, month, day, hour, min, sec) {

		console.log("--- handleVideoTimeChangeExecute - hour = " + hour);
		
		this.requestMoreVideoChunksYN = false;

		var reactID = this.props.reactID;
		var locationID = this.props.locationID;
		var cameraID = this.props.cameraID;

		var jsonObj = null;
		
		if (liveYN) {
			jsonObj = {
				command: "playVideoDateTime",
				reactID: reactID,
				locationID: locationID,
				liveYN: true,
			};
		} else {
			jsonObj = {
				command: "playVideoDateTime",
				reactID: reactID,
				locationID: locationID,
				liveYN: false,
				year: year,
				month: month,
				day: day,
				hour: hour,
				min: min,
				sec: sec,
			};
		}
		
		this.props.textSocketSendJsonObj(jsonObj);
	}

	async handleVideoTimeChange(liveYN, year, month, day, hour, min, sec) {

		if (this.socket !== null) {
			try {
				this.socket.close();
			} catch (err) {
				console.log(err);
			}
		}
		
		this.firstChunkUnixTimeSec = 0;

		var video = this.videoRef.current;
		try {
			if (video.readyState >= 2 && !video.paused) { 
				video.pause();
			}
		} catch (err) {
		}

		try {
			await this.emptySourceBuffer(this.sourceBuffer); 
		} catch (err) {
		}
		this.videoRef.current.currentTime = 0;

		var unixTimeMs = Date.now();
		var diffMs = unixTimeMs - this.videoTimeChangedUnixTimeMs;
		this.videoTimeChangedUnixTimeMs = unixTimeMs;
		
		if (diffMs < 2000) {
			this.videoTimeChangedYN = true;
			return;
		}
		
		this.handleVideoTimeChangeExecute(liveYN, year, month, day, hour, min, sec);
	}

	createNewStream() {

		var reactID = this.props.reactID;
		var companyID = this.props.companyID;
		var locationID = this.props.locationID;
		var cameraID = this.props.cameraID;

		var jsonObj = {
			command: "createNewStream",
			reactID: reactID,
			companyID: companyID,
			locationID: locationID,
			cameraID: cameraID,
		};
		
		this.props.textSocketSendJsonObj(jsonObj);
	}
		
	removeStream() {

		var reactID = this.props.reactID;
		var locationID = this.props.locationID;

		var jsonObj = {
			command: "removeStream",
			reactID: reactID,
			locationID: locationID,
		};
		
		this.props.textSocketSendJsonObj(jsonObj);
	}
	
	renderDateInput() {
		
		var liveYN = this.state.liveYN;
		if (liveYN) {
			return;
		}

		var dateObj = this.getDateObjFromYMD(this.state.year, this.state.month, this.state.day);

		return (
			<center>
				<div className="CourtMainDateContainer">
					<div className="CourtMainDatePrev" onClick={() => this.prevDate()}>&lt;&lt;</div>
					<DatePicker 
						className="CourtMainDateString" 
						selected={dateObj} onChange={(date) => this.datePickerSetDate(date)} 
						dateFormat="dd.MM.yyyy."
					/>
					<div className="CourtMainDateNext" onClick={() => this.nextDate()}>&gt;&gt;</div>
				</div>
			</center>
		);
	}

	renderHourInput() {
		
		var liveYN = this.state.liveYN;
		if (liveYN) {
			return;
		}

		return (
			<center>
				<div className="CourtMainDateContainer">
					<div className="CourtMainDatePrev" onClick={() => this.prevHour()}>&lt;&lt;</div>
					<input 
						className="CourtMainDateString" 
						value={this.state.hour}
						onChange={e => this.setHour(e.target.value)}
						onBlur={e => this.setHourOnBlur(e.target.value)}
					/>
					<div className="CourtMainDateNext" onClick={() => this.nextHour()}>&gt;&gt;</div>
				</div>
			</center>
		);
	}
	
	setSliderValue(value) {

		var min = Math.floor(value / 60);
		var sec = value - 60*min;

		this.setState({
			sliderMin: min,
			sliderSec: sec,
		});
	}
	
	setSliderValueChangeComplete(value) {
		
		var min = Math.floor(value / 60);
		var sec = value - 60*min;

		this.setState({
			min: min,
			sec: sec,
			sliderMin: min,
			sliderSec: sec,
		});

		this.handleVideoTimeChange(this.state.liveYN, this.state.year, this.state.month, this.state.day, this.state.hour, min, sec);
	}
	
	renderMinInput() {

		var liveYN = this.state.liveYN;
		if (liveYN) {
			return;
		}
		
		var min = this.state.sliderMin;
		var sec = this.state.sliderSec;
		var value = 60*min + sec;

		return (
			<div className="CourtStreamSliderContainer">
				<Slider 
					min={0} 
					max={3599} 
					value={value} 
					onChange={(val) => this.setSliderValue(val)}
					onChangeComplete={(val) => this.setSliderValueChangeComplete(val)}
				/>
			</div>
		);
	}

	handleRequestClipButtonPressedMouseDown() {
		this.setState({requestClipButtonPressedYN: true});
	}
	
	handleRequestClipButtonPressedMouseUp() {

		this.props.showToast(this.props.getLang(CourtLang, "requestClipSent"));		
		this.setState({requestClipButtonPressedYN: false});

		var companyID = this.props.companyID;
		var locationID = this.props.locationID;
		var courtID = this.props.courtID;
		var cameraID = this.props.cameraID;
		var year = this.state.year;
		var month = this.state.month;
		var day = this.state.day;
		var hour = this.state.hour;
		var min = this.state.min;
		var sec = this.state.sec;

		var jsonObj = {
			command: "requestVideoClip",
			companyID: companyID,
			locationID: locationID,
			courtID: courtID,
			cameraID: cameraID,
			year: year,
			month: month,
			day: day,
			hour: hour,
			min: min,
			sec: sec
		};
		
		this.props.textSocketSendJsonObj(jsonObj);
	}
	
	handleRequestClipButtonPressedTouchStart() {
		this.handleRequestClipButtonPressedMouseDown();
	}

	handleRequestClipButtonPressedTouchEnd() {
		this.handleRequestClipButtonPressedMouseUp();
	}
	
	renderRequestClipButton() {
		
		var liveYN = this.state.liveYN;
		if (liveYN) {
			return;
		}

		var buttonPressedYN = this.state.requestClipButtonPressedYN;

		return (
			<div className="CourtStreamRequestClipButton" 
				onTouchStart={() => this.handleRequestClipButtonPressedTouchStart()} 
				onTouchEnd={() => this.handleRequestClipButtonPressedTouchEnd()} 
				onMouseDown={() => this.handleRequestClipButtonPressedMouseDown()} 
				onMouseUp={() => this.handleRequestClipButtonPressedMouseUp()} 
			>
				{!buttonPressedYN && (<MdRadioButtonChecked style={{ padding: "5px", color: "black", width: "25px", height: "25px" }} />)}
				{buttonPressedYN && (<MdRadioButtonChecked style={{ padding: "5px", color: "blue", width: "30px", height: "30px" }} />)}
			</div>
		);
	}

	renderControls() {
		
		var liveYN = this.state.liveYN;
		var liveClassName = "CourtStreamLive1";
		if (liveYN) {
			liveClassName = "CourtStreamLive2";
		}
		
		return (
			<div>
				<div className={liveClassName} onClick={() => this.handleLiveClick()}>LIVE</div>
				<div style={{height: "10px"}}></div>
				{this.renderMinInput()}
				{this.renderHourInput()}
				{this.renderDateInput()}
				{this.renderRequestClipButton()}
			</div>
		);
	}
	
	renderVideoStream() {
		return (
			<video 
				ref={this.videoRef} 
				autoPlay 
				muted 
				style={{ width: '100%', maxWidth: '1000px', height: 'auto' }}
			/>
		);
	}
	
	render() {

		return (
			<div className="CourtStreamTopContainer">
				<div style={{height: "10px"}}></div>
				{this.renderVideoStream()}
				<div style={{height: "10px"}}></div>
				{this.renderControls()}
				<div style={{height: "10px"}}></div>
			</div>
		);
	}
}

export default CourtStream;